import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M22.67,16.94a1.22,1.22,0,0,0-1.22,1.21V20a1.57,1.57,0,0,1-1.57,1.57H4.12A1.57,1.57,0,0,1,2.55,20V18.15a1.22,1.22,0,0,0-2.43,0V20a4,4,0,0,0,4,4H19.88a4,4,0,0,0,4-4V18.15A1.21,1.21,0,0,0,22.67,16.94Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M12,0a1.94,1.94,0,0,0-1.94,1.94V11a.25.25,0,0,1-.25.25H7.15a1,1,0,0,0-.73,1.6l4.85,5.58a1,1,0,0,0,1.46,0l4.85-5.58a1,1,0,0,0-.73-1.6H14.19a.25.25,0,0,1-.25-.25V1.94A1.94,1.94,0,0,0,12,0Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }